import React from 'react';

const ImageShow = ({images}) => {
    return (
        <div>
        <img className='rounded' src={images.urls.small} alt={images.alt_description} />
        </div>
    );
}

export default ImageShow;
